import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalNuevoConvenioComponent } from '../contratos/modal-nuevo-convenio/modal-nuevo-convenio.component';
import { ActivatedRoute } from '@angular/router';
import { CuentasPorCobrarService } from '../../services/cuentas-por-cobrar.service';

@Component({
  selector: 'app-convenios',
  templateUrl: './convenios.component.html',
  styleUrls: ['./convenios.component.scss']
})
export class ConveniosComponent implements OnInit {

    public errors: any = {};
    public puntosINPC: any [] = [];
    public unidadesIncremento: any [] = [];
    public contrato: any = {};
    public convenios: any = [];
    public id_contrato:number=0;
    public rentas: any [] = [];

    //paginacion
    paginate:any = {};
    page: number = 1;
    pageSize: number = 10;
    pageAll: number = 100;
    lastPage: any = 1;

    //helpers
    public esValidoCrearNuevoConvenio: boolean = false;
    public loadingNuevoConvenio: boolean = false;

    public loading:boolean=false;

    @ViewChild(ModalNuevoConvenioComponent) modal_nuevo_convenio:ModalNuevoConvenioComponent;

    constructor(private cuentas_por_cobrar_service:CuentasPorCobrarService, 
                        private route:ActivatedRoute) {
        
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
        var id_contrato = params['id_contrato'];
            if(id_contrato){
                this.id_contrato = id_contrato;
                this.recargarListaConvenios();
            }
        });
      
    }

    loadConvenios(id_contrato){
        this.loading = true;
        this.cuentas_por_cobrar_service.listarConvenios(this.page, id_contrato)
        .subscribe(
            (response)=>{
                this.loading = false;
                this.convenios = response.json().content.data;
                if(this.convenios && this.convenios.length>0){
                    var c = this.convenios[0];
                    this.contrato={id_contrato: c.id_contrato,
                        rfc: c.rfc_contrato,
                    razon_social: c.miembro_contrato};
                }

                this.paginate = response.json().content;
                this.page = this.paginate.current_page;
                this.pageSize = this.paginate.per_page;
                this.pageAll = this.paginate.total;
                this.loading = false;

            },
            (error)=>{
                this.loading = false;
                alert("ERROR: "+JSON.stringify(error));
            }
        );
    }

    public validarCrearNuevoConvenio(id_contrato){
        this.loadingNuevoConvenio = true;
        this.cuentas_por_cobrar_service.esUnContratoValidoParaCrearUnNuevoConvenio(id_contrato)
        .subscribe(
            (response)=>{
                this.esValidoCrearNuevoConvenio = response.json().content.esValido;
                this.loadingNuevoConvenio = false;
            },
            (error)=>{
                this.loadingNuevoConvenio = false;
                alert("ERROR: "+JSON.stringify(error));
            }
        );
    }

    // MAIN SECTIONS FUNCTIONS     
    writePermission() {
        return true;
    }

    canExport() {
        return true;
    }

    mostrarNuevoConvenioModal(){
        this.modal_nuevo_convenio.openModalNuevoConvenio(this.id_contrato, false, true, false);
    }

    mostrarConvenioExistenteModal(convenio, editable, autorizable){
        //TODO: Si es editable, validar que el owner del convenio sea el mismo que esta firmado
        this.modal_nuevo_convenio.openModalNuevoConvenio(this.id_contrato, convenio.id_convenio, editable, autorizable);
    }

    public eliminarConvenioExistente(convenio){
        if(confirm("¿Deseas eliminar el convenio?")){
            this.cuentas_por_cobrar_service.eliminarConvenio(convenio.id_convenio)
            .subscribe(
                (response)=>{
                    this.recargarListaConvenios();
                },
                (error)=>{
                    alert("ERROR:: "+JSON.stringify(error));
                }
            );
        }
    }

    public aplicarDespuesDeActualizarConvenios(){
        this.recargarListaConvenios();
    }

    private recargarListaConvenios(){
        //Si se creo un nuevo contrato, hay que validar que siga siendo valido el crear uno nuevo
        this.validarCrearNuevoConvenio(this.id_contrato);
        //Actualizar la tabla de convenios, para que se muestren los nuevos convenios
        this.loadConvenios(this.id_contrato);
    }

    pageChanged($event){
        this.page = $event;
        this.loadConvenios(this.id_contrato);
    }
}


// WEBPACK FOOTER //
// ./src/app/components/convenios/convenios.component.ts